import * as angular from "angular";

export class InviteService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/campaign/invite";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.v2Root + "/all", data);
    }

    user(): Promise<object> {
        return this.$http.get(this.v2Root + "/user");
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    resend(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/resend", data);
    }

    bulkActivate(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_activate", data);
    }

    bulkResend(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_resend", data);
    }

    bulkDelete(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_delete", data);
    }

    remove(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/", data);
    }

    accept(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/accept/" + data.id, data);
    }

    decline(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/decline/" + data.id, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/" + data.campaigninviteid, data);
    }
}

angular.module("vcServices").service("InviteService", InviteService);
